import { MyItemsTable, useMyReviewItems } from "./MyItemsTable";
import { usePhysicianReviewLive } from "../hooks/usePhysicianReviewLive";

/** The My Items sidebar page: exactly the dashboard's "My items" list, on its own. */
export function MyItemsView({ onOpenItem }: { onOpenItem: (id: string) => void }) {
  const mine = useMyReviewItems();
  // Live: assignments, replies and releases refresh the list (the shared queue isn't shown here).
  usePhysicianReviewLive(() => {}, () => void mine.refresh());
  return (
    <div className="min-h-full bg-[#F7F7F7] px-4 py-4 lg:px-6 lg:py-5">
      <div className="rounded-3xl border border-[#E5E7EB] bg-white p-5 shadow-sm">
        <h2 className="!mb-4 text-base font-extrabold text-[#0A2947]">
          My items <span className="font-semibold text-[#9CA3AF]">({mine.data?.length ?? 0})</span>
        </h2>
        <MyItemsTable items={mine.data ?? []} loading={mine.loading} onOpenItem={onOpenItem} />
      </div>
    </div>
  );
}
